


const _SET_GA4_MEASUREMENT_ID = 'G-8HYLD56CB6';
  
window.dataLayer = window.dataLayer || [];

  if (window.dataLayer) {
    console.log('1--window--layer');
  } else {
    console.log('2--window--layer');
  }

  window._triggerGA4Tag = function() {
    dataLayer.push(arguments);
  };
      
  _triggerGA4Tag('js', new Date());

  _triggerGA4Tag('config', _SET_GA4_MEASUREMENT_ID, {
    send_page_view: false
  });

// A $( document ).ready() block.
window.addEventListener('DOMContentLoaded', (event) => {
  try{

    console.log( "ready!" );

  // trigger page views
  _triggerGA4Tag('event', 'page_view', {
    page_title: document.title,
    page_location: window.location.href
  });

  
} catch(eg) {
  console.log('---error ga4---%j', eg);
}
})
